export const orgPath = (orgId: string, suffix = '') => {
  if (!orgId) return '/org/select';
  const path = !suffix ? '' : suffix.startsWith('/') ? suffix : `/${suffix}`;
  return `/org/${orgId}${path}`;
};
